const baseQueryParams = {
  publicationState: 'live',
  sort: 'updatedAt:desc',
  pagination: {
    page: 1,
    pageSize: 24,
  },
};

export const topBlogsQueryParams = {
  ...baseQueryParams,
  fields: [
    'blog_title',
    'blog_url',
    'updatedAt',
    'publishedAt',
    'is_top',
    'author_name',
    'excerpt',
    'description',
    'view_count',
  ],
  filters: {
    is_top: true,
  },
  populate: {
    featured_image: {
      fields: ['url', 'name'],
    },
    updated_by_user: {
      fields: ['name', 'designation', 'author_bio'],
      populate: {
        profile_picture: { fields: ['url', 'name'] },
      },
    },
    created_by_user: {
      fields: ['name', 'designation', 'author_bio'],
      populate: {
        profile_picture: { fields: ['url', 'name'] },
      },
    },
  },
  pagination: { ...baseQueryParams.pagination, pageSize: 7 },
};

export const blogsQueryParams = {
  ...baseQueryParams,
  fields: [...topBlogsQueryParams.fields],
  populate: {
    ...topBlogsQueryParams.populate,
    tags: true,
    categories: {
      fields: ['category_name'],
    },
  },
};

export const featuredBlogQueryParams = {
  ...blogsQueryParams,
  filters: {
    is_featured: true,
  },
  categories: {
    fields: ['category_name'],
  },
};

export const categoriesQueryParams = {
  publicationState: 'live',
  sort: 'blog_cateogery_sequence:asc',
  pagination: {
    page: 1,
    pageSize: 30,
  },
  fields: ['category_name'],
  filters: {
    blogs: {
      publishedAt: {
        $notNull: true,
      },
    },
  },
  populate: {
    logo: {
      fields: ['url', 'name'],
    },
    tags: true,
    blogs: {
      count: true,
    },
  },
};

export const getBlogQueryParams = (page: number) => {
  return {
    ...blogsQueryParams,
    pagination: {
      ...baseQueryParams.pagination,
      page,
    },
  };
};
